/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { subscriptionsSearchSubscriptions } from "../../funcs/subscriptionsSearchSubscriptions.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  pageNumber: z.number().default(1),
  pageSize: z.number().default(10),
};

export const tool$subscriptionsSearchSubscriptions: ToolDefinition<
  typeof args
> = {
  name: "subscriptions-search-subscriptions",
  description: `List all subscriptions

Search and retrieve a paginated list of subscriptions. View status, billing cycle, and customer info.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await subscriptionsSearchSubscriptions(
      client,
      args.pageNumber,
      args.pageSize,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
